import React from "react";
import gql from "graphql-tag";
import { Subscription } from "react-apollo";
import { httpClient } from "../../../settings/apolloClient";
import SUBSCRIBE_TO_SENSOR_CHANGES from "../graphql/subscriptions/subscribeToSensorMeasurementChanges.js";

const SENSOR_LAST_MEASUREMENT_FRAGMENT = gql`
  fragment SensorLastMeasurement on Sensor {
    lastMeasurement
  }
`;

// Keeps the sensor value live by writing each measurement into the httpClient
// cache. Renders nothing; the value is displayed by whoever reads the cache
// (SENSORS_QUERY for the scales panel, SILO_LOCATIONS_QUERY for the silo panel).
// Writing to the cache instead of rendering directly means the last value
// persists across tab switches even if this subscription is briefly torn down
// and recreated, and it sidesteps the @absinthe/socket resubscribe race that
// used to leave scales stuck at 0 after remount.
export const SensorMeasurementSubscriber = ({ id }) => (
  <Subscription
    subscription={SUBSCRIBE_TO_SENSOR_CHANGES}
    fetchPolicy="no-cache"
    variables={{ id }}
    onSubscriptionData={({ subscriptionData }) => {
      const measurement = subscriptionData
        && subscriptionData.data
        && subscriptionData.data.subscribeToSensorMeasurementChanges;

      if (measurement === undefined || measurement === null) return;

      httpClient.writeFragment({
        id: `Sensor:${id}`,
        fragment: SENSOR_LAST_MEASUREMENT_FRAGMENT,
        data: {
          __typename: "Sensor",
          lastMeasurement: measurement,
        },
      });
    }}
  >
    {() => null}
  </Subscription>
);

// Uma inscrição por sensor, montada num só lugar: os painéis que mostram
// medição apenas leem o cache, sem duplicar inscrição para o mesmo sensor.
const SensorMeasurementSubscribers = ({ sensors = [] }) => (
  <React.Fragment>
    {sensors.map(sensor => (
      <SensorMeasurementSubscriber key={sensor.id} id={sensor.id} />
    ))}
  </React.Fragment>
);

export default SensorMeasurementSubscribers;
